import { DateTime } from 'luxon'

/**
 * VAT database.
 */
export class VAT {

  static for(iso3166: string, date: Date | string = new Date()): number {
    const day = typeof date === 'string' ? DateTime.fromISO(date).toFormat('yyyy-MM') : DateTime.fromJSDate(date).toFormat('yyyy-MM')

    if (iso3166 === 'FI') {
      if (day >= '2022-12' && day < '2023-05') {
        return 0.10
      }
      if (day >= '2023-05' && day < '2024-09') {
        return 0.24
      }
      return 0.255
    }
    return 0
  }
}
